import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Css from './Desktop.scss';
import { Link } from 'react-router-dom';

class Desktop extends Component {
  render() {
    return (
      <React.Fragment>
        <div className={Css.header}>Membership Level Benefits</div>
        <Container fluid={true} className={Css.container + ' asap-regular'}>
          <Row className={Css.headings + ' asap-bold'}>
            <Col md="6" />
            <Col md="2">EXECUTIVE</Col>
            <Col md="2">CHAIRMAN</Col>
            <Col md="2">FOUNDER</Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">Guaranteed Fixed Hourly Rates</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">24/7/365 Availability</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>

          <Row className={Css.row}>
            <Col md="6">Book Trips with as Little as 48 Hours Notice</Col>

            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">No Repositioning Fees or Fuel Surcharges</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">First Flight Welcome Gift</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">Gourmet In-Flight Catering</Col>
            <Col md="2">{}</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6" style={{ lineHeight: '100%' }}>
              Exclusive Access to a Dedicated Account Manager to Assist You
              Every Step of the Way
            </Col>
            <Col md="2">{}</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">
              Complimentary{' '}
              <Link to={'/partners/blade'} className={'color-red'}>
                Blade
              </Link>{' '}
              Helicopter One-Way Transfers
            </Col>
            <Col md="2">{}</Col>
            <Col md="2" className={Css.info}>
              2
            </Col>
            <Col md="2" className={Css.info}>
              4
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">
              $1500 Credit towards a{' '}
              <Link to={'/jetsuite-experiences'} className={'color-red'}>
                JetSuite Experience by Embark
              </Link>
            </Col>
            <Col md="2">{}</Col>
            <Col md="2" className={Css.info}>
              1
            </Col>
            <Col md="2" className={Css.info}>
              2
            </Col>
          </Row>
          <Row className={Css.row}>
            <Col md="6">
              Access to Year-Long Exclusive{' '}
              <Link to={'/jetsuite-experiences'} className={'color-red'}>
                JetSuite Experiences
              </Link>
              , Preferred Hotel, Luxury Car and Other Partner Benefits
            </Col>
            <Col md="2">{}</Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
            <Col md="2" className={Css.checkmark}>
              <FontAwesomeIcon icon={['fas', 'check']} />
            </Col>
          </Row>
          <Row>
            <Col md="12" className={Css.footnote}>
              <em>*Additional terms and conditions may apply.</em>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Options/BenefitsContent/Desktop/Desktop.js